import BaseParser from './BaseParser';
import _get from 'lodash/get';
import { BaseParserOptions, AddressOptions } from './SharedTypes';

class Identifier extends BaseParser {
  private options: BaseParserOptions;

  /**
   * @param {boolean} options.address.omitLineBreaks - If true, line breaks will not be added
   * @param {string} options.address.lineBreakString - If line breaks ommitted, char used to specify split in lines
   */
  constructor(options = {}) {
    super();

    this.options = options;
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Address = {}) {
    if (fhirProperty === null || fhirProperty === undefined) return null;

    const { omitLineBreaks = false, lineBreakString = ' ' } = _get<
      BaseParserOptions,
      'address',
      AddressOptions
    >(this.options, 'address', {});

    const { line = [], city, state, postalCode } = fhirProperty;

    return [...line, [city, state, postalCode].filter(v => v).join(' ')]
      .filter(v => v)
      .join(omitLineBreaks ? lineBreakString : '<br>');
  }
}

export default Identifier;
